import { AbstractWallet } from '@blink/components/src/utils';
import { call, put, select } from 'redux-saga/effects';
import { Provider, Signer } from 'ethers';

import { Store } from '@/shared/store';
import { getSafeSigner } from '@/shared/utils/getSafeSigner';
import { getWalletMap } from '@/shared/utils/getWalletMap';

export function* getWalletInfoSaga(
    onFailAction: (action: any) => any,
): Generator<any, { walletAddress: string; signer: Signer | Provider } | null, any> {
    const { type, blockchainName, walletAddress } = yield select((state: Store) => ({
        type: state.wallets.active.type,
        blockchainName: state.wallets.network,
        walletAddress: state.wallets.active.address,
    }));

    const walletMap = getWalletMap();

    const wallet: AbstractWallet = walletMap.get(type) as AbstractWallet;

    if (!wallet) {
        yield put(onFailAction([]));
        return null;
    }

    const walletProvider = yield call([wallet, wallet.getProvider]);
    const signer = yield call(getSafeSigner, walletProvider, blockchainName);

    return { walletAddress, signer };
}
